import Cookies from "js-cookie";

export const getToken = () => {
    const authAccessString = Cookies.get("loginToken");
    const authAccess = authAccessString ? authAccessString : null;
    return authAccess ? authAccess : null;
  };

  export function decodeJWT(token: string) {
    if(token!==null){
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
  
    return JSON.parse(jsonPayload);}else{
      return null
    }
  }
  